import React from 'react'

import OneLineEditor from '../../components/OneLineEditor'
import CheckBox from '../../components/CheckBox'
import SelectBox from '../../components/SelectBox'
import RadioButton from '../../components/RadioButton'

import EstimationEditTab from './EstimationEditTab'
import EstimationSheetTab from './EstimationEdit/EstimationSheetTab'
import PrefectureList from '../../libs/PrefectureList'
import Utils from '../../libs/Utils'
import LaborUnitPriceTab from './EstimationEdit/LaborUnitPriceTab'
import LaborCostTab from './EstimationEdit/LaborCostTab'
import MaterialCostTab from './EstimationEdit/MaterialCostTab'

import EstimationStore from '../../libs/EstimationStore'
import EstimationActions from '../../libs/EstimationActions'

import EstimationManagement from './abstract/EstimationManagement'

import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'

class EstimationEdit extends EstimationManagement {
  constructor (props) {
    super(props)
    EstimationActions.setEditableMode(true)
    this.state = {
      isLoaded: false,
      currentTab: this.props.currentTab,
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  componentWillMount () {
    const {params} = this.props.match
    const estimationId = params.estimationId
    this.loadEstimation(estimationId)
    this.loadEstimationCategoryList()
  }
  onTabClick (tabId) {
    this.setState({currentTab: tabId})
  }
  onPageMenuClicked (name) {
    const {params} = this.props.match
    const estimationId = params.estimationId
    switch (name) {
      case 'back':
        Window.confirm('編集モードから戻ります。\n変更内容を保存していない場合は編集内容が反映されません。よろしいですか？', () => {
          Window.closeDialog()
          this.props.history.push('/company_user/estimation/' + this.estimationType + '/detail/' + estimationId)
        })
        break
      default:
        break
    }
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    switch (name) {
      case 'save':
        Window.confirm('保存してよろしいですか?\nこの処理の後は保存前の状態には戻せません', () => {
          const {params} = this.props.match
          const estimationId = params.estimationId
          const estimationData = EstimationActions.getCurrentEstimation()
          estimationData.estimationId = estimationId // defaultで置き換えているので元に戻す
          this.saveEstimation(estimationData, 'update')
        })
        break
      case 'cancel':
        Window.confirm('保存前の状態にリセットしてよろしいですか?\nこの処理は元には戻せません', () => {
          Window.alert('保存前の状態にリセットしました。', () => {
            window.location.reload() // 同じコンポーネントなので
          })
        })
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const estimationCategoryList = this.state.categoryList
    const pageHeaderMain = this.isTemplate ? '雛型' : '見積書'
    const pageHeaderSub = this.isTemplate ? 'こちらから雛型の作成・編集・削除ができます。' : 'こちらから標準見積書の作成・編集・削除ができます。'

    const estimationTab = (
      <section className='page container'>
        <EstimationEditTab onTabClick={this.onTabClick.bind(this)} currentTabId={this.state.currentTab} />
        <div className='alert alert-block alert-info'>
          <h5>【見積書カテゴリー】</h5>
          <SelectBox bindingDataAttribute='estimationCategoryId' options={estimationCategoryList}
            valueAttributeName='id' captionAttributeName='name' />
          <div className='kw-clear' />
          <h5>【見積書表示設定】</h5>
          <label htmlFor='primeContractorInputMode' className='kw-pointer'><CheckBox bindingDataAttribute='primeContractorInputMode' idForLabel='primeContractorInputMode' />元請会社用の金額欄を設ける</label>
          <div className='kw-clear' />
          <h5>【消費税設定】</h5><table className='kw-input-tbl'><tbody><tr><th>消費税:</th><td className='text-right kw-inputable'><OneLineEditor bindingDataAttribute='estimationConfigTax' isNum textAlign='right' /></td><td>%</td></tr></tbody></table>
        </div>
        <div style={{overflowX: 'scroll'}} >
          <EstimationSheetTab isEditable />
        </div>
      </section>
    )
    const yearMonthList = Utils.getYMList()
    const laborUnitPriceTab = (
      <div>
        <section className='page container'>
          <EstimationEditTab onTabClick={this.onTabClick.bind(this)} currentTabId={this.state.currentTab} />
          <div className='alert alert-block alert-info'>
            <h5>【労務単価入力設定】</h5><h6>都道府県:</h6>
            <SelectBox bindingDataAttribute='estimationPrefectureId' callback={EstimationActions.selectPrefecture} options={PrefectureList} />
            <h6>保険料率設定年月:</h6>
            <SelectBox bindingDataAttribute='estimationYearMonthId' callback={EstimationActions.selectYearMonth} options={yearMonthList} />

            <h6>基準単価(型枠大工):</h6>
            <label htmlFor='TedoriA' className='kw-pointer'><RadioButton bindingDataAttribute='daikuLaborUnitPriceType' idForLabel='TedoriA' attributeValue='Tedori' />日額手取り賃金</label>
            <label htmlFor='HonninA' className='kw-pointer'><RadioButton bindingDataAttribute='daikuLaborUnitPriceType' idForLabel='HonninA' attributeValue='Honnin' />日額賃金(本人負担含む)</label>
            <label htmlFor='HukuriA' className='kw-pointer'><RadioButton bindingDataAttribute='daikuLaborUnitPriceType' idForLabel='HukuriA' attributeValue='Hukuri' />法定福利費込日額人件費</label>
            <label htmlFor='SekkeiA' className='kw-pointer'><RadioButton bindingDataAttribute='daikuLaborUnitPriceType' idForLabel='SekkeiA' attributeValue='Sekkei' callback={EstimationActions.selectSekkeiUnitPriceType} />公共工事設計労務単価</label>
            <div className='kw-clear' />

            <h6>基準単価(型枠解体工):</h6>
            <label htmlFor='TedoriB' className='kw-pointer'><RadioButton bindingDataAttribute='kaitaiLaborUnitPriceType' idForLabel='TedoriB' attributeValue='Tedori' />日額手取り賃金</label>
            <label htmlFor='HonninB' className='kw-pointer'><RadioButton bindingDataAttribute='kaitaiLaborUnitPriceType' idForLabel='HonninB' attributeValue='Honnin' />日額賃金(本人負担含む)</label>
            <label htmlFor='HukuriB' className='kw-pointer'><RadioButton bindingDataAttribute='kaitaiLaborUnitPriceType' idForLabel='HukuriB' attributeValue='Hukuri' />法定福利費込日額人件費</label>
            <div className='kw-clear' />
          </div>
          <div style={{overflowX: 'scroll'}} >
            <LaborUnitPriceTab isEditable />
          </div>
        </section>
      </div>
    )
    const laborCostTab = (
      <div>
        <section className='page container'>
          <EstimationEditTab onTabClick={this.onTabClick.bind(this)} currentTabId={this.state.currentTab} />
          <div style={{overflowX: 'scroll'}} >
            <LaborCostTab isEditable />
          </div>
        </section>
      </div>
    )
    const materialCostTab = (
      <div>
        <section className='page container'>
          <EstimationEditTab onTabClick={this.onTabClick.bind(this)} currentTabId={this.state.currentTab} />
          <div className='alert alert-block alert-info'>
            <h5>【材料費入力設定】</h5>
            <label htmlFor='materialCostDetailInputMode' className='kw-pointer'><CheckBox bindingDataAttribute='materialCostDetailInputMode' idForLabel='materialCostDetailInputMode' />材料費を詳細に設定する</label>
            <div className='kw-clear' />
          </div>
          <div style={{overflowX: 'scroll'}} >
            <MaterialCostTab isEditable />
          </div>
        </section>
      </div>
    )

    let currentTabToShow = []
    switch (this.state.currentTab) {
      case 'EstimationSheetTab':
        currentTabToShow = estimationTab
        break
      case 'LaborUnitPriceTab':
        currentTabToShow = laborUnitPriceTab
        break
      case 'LaborCostTab':
        currentTabToShow = laborCostTab
        break
      case 'MaterialCostTab':
        currentTabToShow = materialCostTab
        break
      default:
        break
    }
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span13'>
                <header className='page-header'>
                  <h3>{pageHeaderMain} - {EstimationActions.getCurrentEstimation().estimationTitle}<br />
                    <small>{pageHeaderSub}</small>
                  </h3>
                </header>
              </div>
              <div className='span3'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'>
                    <button onClick={(e) => this.onPageMenuClicked('back')} rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary'>
                      <i className='icon-arrow-left icon-large' /><span>戻る</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className='alert alert-block alert-info'>
          <div className='container kw-content-area'>
            <h4>[編集モード]</h4>
            <div className='kw-space3' />
            <p>
              背景が<span className='kw-non-inputable'>黄色の部分</span>をクリックするとこの画面で編集できます。(Enterキーを押すか、黄色以外の部分をクリックすると変更が確定します)<br />
            </p>
            <p>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM' onClick={e => this.onFormButtonClicked('save', e)}>この{pageHeaderMain}の内容を保存する</button>
              <button className='btn' style={{marginLeft: '10px'}}onClick={(e) => this.onFormButtonClicked('cancel', e)}>保存前の状況にリセット</button>
            </p>
            <p style={{marginBottom: 0, color: 'red'}}>
              ※セキュリティの関係上、見積書は1時間毎に1回以上[この{pageHeaderMain}の内容を保存する]ボタンより保存を行うようにしてください。
            </p>
            <p style={{marginBottom: 0, color: 'red', paddingLeft: '0.6em'}}>
              行わなかった場合、保存をするタイミングでログアウトされる可能性がございますので十分にご注意ください。
            </p>
          </div>
        </div>
        <div>
          {currentTabToShow}
        </div>
      </div>
    )
  }
}
EstimationEdit.defaultProps = {currentTab: 'LaborUnitPriceTab'}
export default EstimationEdit



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit.js